<template>
  <div class="d-flex flex-column gap-5">
    <div class="d-flex flex-column gap-2">
      <span class="label typography-body-sm-bold">
        {{ t('yard.drawers.createTaskDrawer.labels.describeTheTask') }}
      </span>

      <v-textarea
        data-testid="yard-task-check-description"
        color="primary"
        variant="outlined"
        hide-details="auto"
        v-model="descriptionValue"
        :disabled="disabledFields?.description"></v-textarea>
    </div>

    <div class="d-flex flex-column gap-2">
      <span class="label typography-body-sm-bold d-flex flex-row align-center gap-1">
        {{ t('yard.drawers.createTaskDrawer.labels.provideAChecklist') }}

        <v-tooltip location="top">
          <template v-slot:activator="{ props }">
            <v-icon
              icon="mdi-help-circle"
              size="small"
              class="text--color-neutral-80"
              v-bind="props"></v-icon>
          </template>
          <span>
            {{
              $t(
                'yard.drawers.createTaskDrawer.tooltips.theChecklistWillBePartOfTheDescriptionToBetterSupportDriversThroughTheTask'
              )
            }}
          </span>
        </v-tooltip>
      </span>

      <yard-tasks-create-task-check-checklist
        v-model="checklistValue"
        :disabled="disabledFields?.checklist"
        @requestValidate="$emit('requestValidate')" />
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

import YardTasksCreateTaskCheckChecklist from './YardTasksCreateTaskCheckChecklist.vue';

export default defineComponent({
  name: 'YardTasksCreateTaskCheckDescription',
  // keeping the input event just for "consistency" with existing components; I don't think it makes sense in such context though
  emits: ['input', 'change', 'requestValidate'],
  components: {
    YardTasksCreateTaskCheckChecklist
  },
  props: {
    description: {
      type: String,
      required: false,
      default: null
    },
    checklist: {
      type: Array,
      required: false,
      default: null
    },
    disabledFields: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  setup(props, { emit }) {
    const { t } = useI18n();

    const descriptionValue = ref(props.description ?? '');
    const checklistValue = ref(props.checklist ?? null);

    watch([descriptionValue, checklistValue], ([newDescription, newChecklist]) => {
      const eventData = {
        description: newDescription,
        checklist: newChecklist
      };

      emit('input', eventData);
      emit('change', eventData);
    });

    return {
      t,
      descriptionValue,
      checklistValue
    };
  }
});
</script>
